export default __webpack_public_path__ + "static/media/MP-GO-Large.bb06e897.png";